import { useMatchRoute } from '@tanstack/react-router'
import { ROUTES } from '@/shared/constants/routes'

export function isExactNavMatch(to: string) {
  return to === ROUTES.HOME
}

export function useActiveNavIndex(items: { to: string }[]) {
  const matchRoute = useMatchRoute()
  return items.findIndex((item) =>
    matchRoute({ to: item.to, fuzzy: !isExactNavMatch(item.to) }),
  )
}
